import React from "react";
import { Typography } from "antd";
import "../App.css"; // Importing the CSS for styling

const { Title, Paragraph } = Typography;

const RecruitmentTransformation = () => {
  return (
    <div id="about" className="transformation-container">
      <Paragraph className="transformation-text">
        Most recruiters go back to LinkedIn or a job board every time a new role opens. ChronoFlow works the other way around: <span className="highlight-text">post a job and it's matched against your existing pool automatically</span>, inviting your strongest-fit candidates before you've sourced a single new lead. The pipeline <span className="highlight-text">updates itself</span> as you make decisions — no CSV imports, no manual data entry. When a passive candidate updates their availability, <span className="highlight-text">you're notified instantly.</span>
      </Paragraph>
    </div>
  );
};

export default RecruitmentTransformation;

